import React from 'react'
import { Provider } from 'react-redux'
import { Flip, ToastContainer } from 'react-toastify'
import store from 'store'
import AppRouter from 'router/AppRouter'

export const App = () => {
  return (
    <Provider store={store}>
      <ToastContainer
        position="top-center"
        autoClose={3500}
        hideProgressBar
        transition={Flip}
        style={{ zIndex: 99999 }}
      />
      <AppRouter />
    </Provider>
  )
}